import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

import {getSelectedPsrsNames, updatePsrsSelected} from '../../services/psr';
import {HideButtonWhenLogout} from '../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../store/slices/chatStore';
import {useEcStore} from '../../store/slices/ecStore';
import {PsrBox} from '../PsrBox/PsrBox';
import './PsrsGroup.style.scss';

export const PsrsGroup = (props) => {
  const cnpj = useEcStore((state) => state.ec.ecBasicData.cnpj);
  const listCodePsr = useChatStore((state) => state.listCodePsr);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setChatInputCode = useChatStore((state) => state.setChatInputCode);
  const setChaListCode = useChatStore((state) => state.setChaListCode);
  const setPsrInputOwnerId = useChatStore((state) => state.setPsrInputOwnerId);
  const [psrsSelectedGroup, setPsrsSelectedGroup] = useState([]);
  const [showButtonPsrSave, setShowButtonPsrSave] = useState(false);
  const [showButtonPsrCancel, setShowButtonPsrCancel] = useState(true);
  const [showButtonPsrOption, setShowButtonPsrOption] = useState(true);

  const savePsrSelectedList = () => {
    setShowButtonPsrSave(false);
    setShowButtonPsrCancel(false);
    setShowButtonPsrOption(false);

    const psrNamesMessage = getSelectedPsrsNames(psrsSelectedGroup);
    setPsrInputOwnerId(props.stepId);
    setChatInputCode(psrsSelectedGroup);

    let psrsSelected = updatePsrsSelected(psrsSelectedGroup, listCodePsr, cnpj);
    setChaListCode(psrsSelected);

    // Adiciona mensagem ao histórico do chat ao invés de renderizar no componente
    if (props.onSave) {
      props.onSave(psrNamesMessage);
    }
  };

  const cancelButton = () => {
    // Limpa seleção antes de cancelar para evitar estado residual
    setPsrsSelectedGroup([]);
    setPsrInputOwnerId(null);
    setShowButtonPsrSave(false);
    setShowButtonPsrCancel(false);
    setShowButtonPsrOption(false);
    props.cancelButton();
  };

  const showPsrs = () =>
    props.showPsr.map((psr) => {
      return (
        <PsrBox
          psr={psr}
          key={psr.id}
          psrsSelectedGroup={psrsSelectedGroup}
          setPsrGroupSelected={setPsrsSelectedGroup}
        />
      );
    });

  useEffect(() => {
    setShowButtonPsrSave(psrsSelectedGroup.length > 0);
    responseTypeChange('disabled');
  }, [psrsSelectedGroup, responseTypeChange]);

  // Cleanup ao desmontar componente
  useEffect(() => {
    return () => {
      setPsrsSelectedGroup([]);
    };
  }, []);

  return (
    <HideButtonWhenLogout>
      <div className="message-line">
        {showButtonPsrOption && (
          <div
            className="box-show-options-psr"
            id="options-psr"
            data-aut-test="options-psr"
          >
            {showPsrs()}
          </div>
        )}
        <div className="container-button">
          {showButtonPsrSave && (
            <button
              className="btn button-save-psr"
              id="save-psrs-selected"
              data-testid="save-psrs-selected"
              data-aut-test="button-save-psrs-selected"
              onClick={() => savePsrSelectedList()}
            >
              Salvar
            </button>
          )}
          {showButtonPsrCancel && (
            <button
              className="btn button-save-psr"
              id="cancelar-psrs-selected"
              data-testid="cancelar-psrs-selected"
              data-aut-test="button-cancelar-psrs-selected"
              onClick={() => cancelButton()}
            >
              Cancelar
            </button>
          )}
        </div>
      </div>
    </HideButtonWhenLogout>
  );
};

PsrsGroup.propTypes = {
  showPsr: PropTypes.array,
  cancelButton: PropTypes.func,
  onSave: PropTypes.func,
  stepId: PropTypes.number
};
